export enum ROUTES {
  //auth
  BASE = "/",
  PAGE_NOT_FOUND = "*",
  LOGIN = "/login",
  ENVIRONMENT = "/environment",
  SIGN_UP = "/signup",
  ADMIN = "/admin",
  AUTH = "/auth",
  DASHBOARD = "/dashboard",
  USER = "/user",
  TENANT = "/tenant",
  TENANT_ADD = "/add",
  TENANT_DETAILS = "/details/",
  ANY_SEPARATOR = "/*",
  USER_DETAILS = "/details/",
  TENANT_MODIFY = "/modify/",
  REPORTS = "/reports",
  RESET_PASSWORD = "/reset-password",
  APPLICATIONS = "/applications",
  TENANT_USERS = "/tenant-users",
  LIST = "/admin-list",
  CREDENTIAL = "/credential",
  CONFIGURATION = "/configuration",
  DOCUMENTATION_REDEEM = "/documentation/redeem",
  DOCUMENTATION_RESERVE = "/documentation/reserve",
  DOCUMENTATION_CREATE_USER = "/documentation/create-user",
  DOCUMENTATION_ADD_TOKENS = "/documentation/add-tokens",
  DOCUMENTATION_SETTLE_TOKENS = "/documentation/settle-tokens",
  DOCUMENTATION_WALLET_TRANSACTIONS = "/documentation/wallet-transactions",
  DOCUMENTATION_REVERT = "/documentation/revert",
  DOCUMENTATION_OVERVIEW = "/documentation/overview",
  DOCUMENTATION_QUICKSTART = "/documentation/quickstart",
  DOCUMENTATION_CHECKLIST = "/documentation/checklist",
  DOCUMENTATION_TOKEN_LIFECYCLE = "/documentation/token-lifecycle",
  DOCUMENTATION_WALLETS = "/documentation/wallets",
  DOCUMENTATION_GEOFENCING = "/documentation/geofencing",
  DOCUMENTATION_TENANT_REGISTRATION = "/documentation/tenant-registration",
  DOCUMENTATION_APP_GAME_SETUP = "/documentation/app-game-setup",
  DOCUMENTATION_USER_MANAGEMENT = "/documentation/user-management",
  DOCUMENTATION_FETCH_WALLET = "/documentation/fetch-wallet",
  DOCUMENTATION_PURCHASE_AND_REDEEM_TOKENS = "/documentation/purchase-and-redeem-tokens",
  DOCUMENTATION_PWA_GUIDE = "/documentation/pwa-guide",
  DOCUMENTATION_IOS_GUIDE = "/documentation/ios-guide",
  DOCUMENTATION_ANDROID_GUIDE = "/documentation/android-guide",
  DOCUMENTATION_ERROR_CODES = "/documentation/error-codes",
  DOCUMENTATION_FAQ = "/documentation/faq",
  DOCUMENTATION_COMING_SOON = "/documentation/coming-soon",
}